import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import Link from '../../../../../components/ZUILib/Link';
import commonUtil from '../../../../../utils/commonUtil';
import InputButton from '../../../../../components/ZUILib/InputButton';
import VerificationPanel from './verificationPanel';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import LoginModal from './loginModal';
import * as typeActions from '../../actions';
import ClosingGiftPanel from './ClosingGiftPanel';
import Tagging from '../../../../../components/Tagging/Tagging';

// const transactionStatusObject = {
//   transactionStatusObject: {
//     emailAddress: 'coowner@gmail.com',
//     bridgeCoreRequest: 'success',
//     monederoAccountInfo: {
//       userName: 'ankitas',
//       bonusAmount: '0.0',
//       commission: '1',
//       commissionFee: '1',
//       totalAmount: '9.0',
//       transferAmount: '10.0',
//       walletType: 'Monedero de Mesa de Regalos',
//       number: 'xxxxxxxxxxxx4567',
//     },
//     closingGiftDetails: [
//       {
//         skuName: 'sku',
//         skuImage: '/product/sku/image02.jpg',
//         addressName: 'Bengalore',
//         remisionNumber: '000050636',
//       },
//       {
//         skuName: 'sku',
//         skuImage: '/product/sku/image03.jpg',
//         addressName: 'Bengalore',
//         remisionNumber: '000050636',
//       },
//       {
//         skuName: 'sku',
//         skuImage: '/product/sku/image04.jpg',
//         addressName: 'Bengalore',
//         remisionNumber: '000050636',
//       },
//     ],
//   },
//   status: {
//     errorMessage: '',
//     errorCode: '',
//     status: 'success',
//   },
// };

const applicationRoutes = commonUtil.getApplicationRoutes();
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const { submitTransference } = typeActions;

class VerificationForm extends Component {

  constructor(props) {
    super(props);
    this.login = this.loginModal1 ? this.loginModal1.login.getValue() : null;
    this.submitTransfernceDataDetails = '';
    this.submit = null;
    this.commissionFee = '';
    this.confirmationButtonDisable = null;
    this.state = {
      submitTransferenceErrorMessage: null,
      info: {
        currentStep: 4,
        total: 4,
      },
    };
  }
  confirmation = () => {
    this.submitTransfernceDataDetails = this.props.submitTransferenceData;
    this.props.nextPage(3);
    // Bug 11416 : P1 Blocker : ICD-GR-PROD-UAT-LIV-ALL-C9-For the migrated event is not showing the modal to enter the password and confirm the transfer
    // if (this.props.transferenceData && this.props.transferenceData.migratedEvent && this.props.transferenceData.migratedEvent.toString() === 'true') {
    //   this.callSubmitTransference();
    // } else {
    //   this.loginModal.handleShow();
    // }
    // this.loginModal.handleShow();
  }
  callSubmitTransference = () => {
    this.submitTransferenceData = Object.assign({}, this.submitTransfernceDataDetails);
    if (this.submitTransferenceData.walletOrEmployeeIdentifierId) {
      /* Added this condition for employee case */
      if (this.props.transferenceData.isEmployee.toString() !== 'true') {
        this.submitTransferenceData.walletType = '0';
      }
    }


    if (this.submitTransferenceData.cardOrBankIdentifierId) {
      this.submitTransferenceData.paymentType = '2';
    }
    delete this.submitTransferenceData.commissionValue;
    delete this.submitTransferenceData.accountNumber;
    delete this.submitTransferenceData.transferDate;
    delete this.submitTransferenceData.cardNumber;
    delete this.submitTransferenceData.paymentMode;
    delete this.submitTransferenceData.bonusPercentage;
    delete this.submitTransferenceData.commissionValue_CardBank;
    delete this.submitTransferenceData.totalAmount_CardBank_View;
    delete this.submitTransferenceData.totalAmount_View;
    delete this.submitTransferenceData.walletUserName;
    delete this.submitTransferenceData.cardBankUserName;
    delete this.submitTransferenceData.skusNames;
    delete this.submitTransferenceData.selectedAddressName;
    delete this.submitTransferenceData.gifts;

    if (!this.submitTransferenceData.selectedAddressId) {
      delete this.submitTransferenceData.selectedAddressId;
    }


    this.props.submitTransference(this.submitTransferenceData).then(() => {
      if (this.props.submitTransferenceResponse.status) {
        if (this.props.submitTransferenceResponse.status.status !== 'failure') {
          browserHistory.push({ pathname: commonUtil.getRouteByParameter(applicationRoutes.closureConfirmation, { eventID: this.submitTransfernceDataDetails.eventId }), state: { submitTransferenceDetails: this.props.submitTransferenceResponse } });
          // eslint-disable-next-line
          dataLayer.push({
            event: 'evClose',
            amount: this.submitTransferenceData.totalAmount,
          });
        } else {
          if (this.props.submitTransferenceResponse.status.errorMessage) {
            if (this.props.submitTransferenceResponse.status.errorMessage === commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.error.message')) {
              this.confirmationButtonDisable = 'disabled';
            }
          }
          this.setState({ submitTransferenceErrorMessage: this.props.submitTransferenceResponse.status.errorMessage });
          commonUtil.goToTop();
        }
      } else {
        this.setState({ submitTransferenceErrorMessage: this.props.submitTransferenceResponse.status.errorMessage });
        commonUtil.goToTop();
      }
    });
  }


  onBackClick = () => {
    this.confirmationButtonDisable = null;
    this.setState({
      submitTransferenceErrorMessage: null,
    });
    this.props.nextPage(1);
  }

  handleHide = () => {
    this.loginModal.handleHide();
  }
  showCursorOnPassword = () => {
    this.loginModalReauthenticate.onHandleShow();
  }
  render() {
    const prevStep = {
      name: 'Regresar',
      type: 'button',
      value: 'Regresar',
      autoFocus: false,
      cssStyle: {
        borderRadius: '4px',
      },
      style: 'btnSecondary size-Large',
      onClickHandler: this.onBackClick,
      id: 'prevStep',
      beforeIconClass: 'iconLeft icon-flecha_light_izq',
    };

    const confirmButton = {
      name: 'Confirmar cierre',
      type: 'button',
      value: 'Siguiente',
      autoFocus: false,
      onClickHandler: this.confirmation,
      style: 'btnPrimary size-Large',
      disabled: this.confirmationButtonDisable,
    };
    const closeModal = {
      name: '×',
      type: 'button',
      value: '×',
      autoFocus: false,
      style: 'close',
      onClickHandler: this.loginModalReauthenticate ? this.loginModalReauthenticate.clearErrorMessages : null,
      id: 'closeModal',
    };
    const confirmLink = {
      id: 'nextStepLink',
      text: 'Confirmar',
      children: 'Confirmar',
      href: '',
      cssStyle: {
        borderRadius: '4px',
      },
      cssClass: this.confirmationButtonDisable === 'disabled' ? 'btnPrimary size-Full hiddenStyle' : 'btnPrimary size-Full closureVerification',
      onClickHandler: this.confirmation,
    };
    const RegresarLink = {
      text: 'Regresar',
      children: 'Regresar',
      href: '',
      cssClass: 'btnSecondary size-Full',
      onClickHandler: this.onBackClick,
    };
    const errorAncher = {
      cssClass: 'icon-tache2',
      onClickHandler: () => { this.setState({ submitTransferenceErrorMessage: null }); },
    };

    const fullContainer = {
      width: channel == constChannels.WEB ? '93%' : null,
      margin: channel === constChannels.WEB ? '4%' : null,
    };

    const alerContainerWeb = {
      border: '1px solid #ADA8A8',
      borderRadius: '20px',
    };

    return (
      <div style={fullContainer}>
        {channel === constChannels.WAP ?
          <React.Fragment>
            <div className="col-xs-12 innerOptions">
              <Tagging ref={tagging => this.tagging = tagging} />
              { this.props.transferenceData && this.props.transferenceData.transferenceOptions
              && this.props.transferenceData.transferenceOptions.transferableAmount
              && parseFloat(this.props.transferenceData.transferenceOptions.transferableAmount) > 0
              ?
                <p
                  style={{ color: '#333333', fontWeight: '400', fontSize: '24px' }}
                >
                  Verificación de cierre de mesa
              </p>
              : null
            }
              <p className="text15w">
                <span style={{ color: '#333333' }}>Fecha de operación&nbsp;&nbsp;</span>
                {this.props.submitTransferenceData && commonUtil.formatDate(this.props.submitTransferenceData.transferDate, 'monthName')}</p>
            </div>

            {this.state.submitTransferenceErrorMessage ? <div className="col-xs-12">
              <div className="alertError">
                <i className="icon-tache2" />
                <p>{this.state.submitTransferenceErrorMessage}</p>
                <Link linkJSON={errorAncher} />
              </div>
            </div> : null}
            {!_.isEmpty(this.props.submitTransferenceData) && this.props.submitTransferenceData.paymentMode !== 'ClosingGift' ?
              <VerificationPanel
                ref={verification => this.verification = verification}
                user={this.props.user} loadFrom="verificationForm"
                submitTransferenceData={this.props.submitTransferenceData}
                isEmployee={this.props.transferenceData.isEmployee}
              />
              : null}

            {this.props.transferenceData.isClosingGiftEligible && this.props.transferenceData.isClosingGiftEligible.toString() === 'true' ?
              <ClosingGiftPanel submitTransferenceData={this.props.submitTransferenceData} loadFrom="verificationForm" lables={this.props.lables} /> : null}

            <div className="col-xs-12">
              <Link linkJSON={confirmLink}>Siguiente<i className="iconRight icon-flecha_lightsvg_derecha" aria-hidden="true" data-original-title title /></Link>
            </div>
          </React.Fragment> :
          <React.Fragment>
            <div className="panel" style={alerContainerWeb}>
              <Tagging ref={tagging => this.tagging = tagging} />
              <div className="panel-body row">
                { this.props.transferenceData && this.props.transferenceData.transferenceOptions
              && this.props.transferenceData.transferenceOptions.transferableAmount
              && parseFloat(this.props.transferenceData.transferenceOptions.transferableAmount) > 0

              ?
                <h3
                  style={{ marginLeft: '20px', paddingTop: '2%', fontFamily: 'Roboto, sans-serif' }}
                >
                    Verificación de cierre
                </h3>
              : null
            }
                <div className="col-xs-12 depositForm">
                  {this.state.submitTransferenceErrorMessage ? <div className="row">
                    <div className="col-xs-6">
                      <div className="alertError">
                        <i className="icon-tache2" />
                        <p>{this.state.submitTransferenceErrorMessage}</p>
                        <Link linkJSON={errorAncher} />
                      </div>
                    </div>
                  </div> : null}

                  {!_.isEmpty(this.props.submitTransferenceData) && this.props.submitTransferenceData.paymentMode !== 'ClosingGift' ?
                    <React.Fragment>
                      <VerificationPanel
                        ref={verification => this.verification = verification}
                        user={this.props.user}
                        loadFrom="verificationForm"
                        submitTransferenceData={this.props.submitTransferenceData}
                        isEmployee={this.props.transferenceData.isEmployee}
                      />
                    </React.Fragment> : null}

                  {this.props.transferenceData.isClosingGiftEligible && this.props.transferenceData.isClosingGiftEligible.toString() === 'true' ?
                    <ClosingGiftPanel submitTransferenceData={this.props.submitTransferenceData} loadFrom="verificationForm" lables={this.props.lables} /> : null}
                </div>
              </div>
            </div>
            <div className="innerButtons">
              <div className="row block-buttons">
                <div className="col-xs-6">
                  <InputButton buttonAttr={prevStep} />
                </div>
                <div className="col-xs-6 text-right">
                  <InputButton buttonAttr={confirmButton} />
                </div>
              </div>
            </div>
          </React.Fragment>

        }
        <ModalPopover showFun={this.showCursorOnPassword} dataBackDrop="false" isModal="true" ref={loginModal => this.loginModal = loginModal} dismiss="false" dismissButton={(<div><InputButton buttonAttr={closeModal} />{channel === 'wap' && <span id="closeModal" className="closeText">Cerrar</span>}</div>)} modalId="myModalConfirmation" header={commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.label4')}>
          <LoginModal ref={loginModalReauthenticate => this.loginModalReauthenticate = loginModalReauthenticate} handleHide={this.handleHide} callSubmitTransference={this.callSubmitTransference} lables={this.props.lables} userEmail={this.props.user.data.result.emailId} />
        </ModalPopover>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  submitTransferenceResponse: state.accountSummary.submitTransference,
});
const matchDispatchToProps = dispatch => bindActionCreators({ submitTransference }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(VerificationForm);
